
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/var/canvas/ui/shared/spinner/jst/_spinner.handlebars";
import "/var/canvas/ui/shared/external-tools/jst/_external_tools_menu.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/quizzes-index/jst/QuizItemView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    class=\"\n    ig-row\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.publishable), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ig-editable\"\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "ig-publishable";
  }

function program4(depth0,data) {
  
  
  return "ig-published";
  }

function program6(depth0,data) {
  
  
  return "\n    class=\"ig-row\"\n  ";
  }

function program8(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"ig-row__layout\">\n    ";
  stack1 = self.invokePartial(partials['ui/shared/spinner/jst/_spinner.handlebars'], 'ui/shared/spinner/jst/_spinner.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "migrating_name_e05aa53e", "Migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "migrating_name_e05aa53e", "Migrating \"%{name}\"", options)))
    + "\n  </div>\n";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.failedToMigrate), {hash:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <span aria-live=\"polite\" role=\"alert\" aria-atomic=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "oops_something_went_wrong_with_migrating_name_acdbc98b", "Oops! Something went wrong with migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "oops_something_went_wrong_with_migrating_name_acdbc98b", "Oops! Something went wrong with migrating \"%{name}\"", options)))
    + "</span>\n  <div class=\"migrate-failed-actions\">\n    <button class=\"migrate-failed-retry btn btn-primary\">\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "retry_migrating_name_bdc802ef", "Retry migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "retry_migrating_name_bdc802ef", "Retry migrating \"%{name}\"", options)))
    + "</span>\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "retry_ebd5f8ba", "Retry", options) : helperMissing.call(depth0, "t", "retry_ebd5f8ba", "Retry", options)))
    + "</span>\n    </button>\n    <button class=\"duplicate-failed-cancel btn\">\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "cancel_migrating_name_cfc745c2", "Cancel migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "cancel_migrating_name_cfc745c2", "Cancel migrating \"%{name}\"", options)))
    + "</span>\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</span>\n    </button>\n  </div>\n";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isDuplicating), {hash:{},inverse:self.program(16, program16, data),fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"ig-row__layout\">\n    ";
  stack1 = self.invokePartial(partials['ui/shared/spinner/jst/_spinner.handlebars'], 'ui/shared/spinner/jst/_spinner.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'original_assignment_name': ((depth0 && depth0.original_assignment_name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "making_a_copy_of_original_assignment_name_8f029a9b", "Making a copy of \"%{original_assignment_name}\"", options) : helperMissing.call(depth0, "t", "making_a_copy_of_original_assignment_name_8f029a9b", "Making a copy of \"%{original_assignment_name}\"", options)))
    + "\n  </div>\n";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.failedToDuplicate), {hash:{},inverse:self.program(19, program19, data),fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program17(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <span aria-live=\"polite\" role=\"alert\" aria-atomic=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'original_assignment_name': ((depth0 && depth0.original_assignment_name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "oops_something_went_wrong_with_making_a_copy_of_or_22787360", "Oops! Something went wrong with making a copy of \"%{original_assignment_name}\"", options) : helperMissing.call(depth0, "t", "oops_something_went_wrong_with_making_a_copy_of_or_22787360", "Oops! Something went wrong with making a copy of \"%{original_assignment_name}\"", options)))
    + "</span>\n  <div class=\"duplicate-failed-actions\">\n    <button class=\"duplicate-failed-retry btn btn-primary\">\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'original_assignment_name': ((depth0 && depth0.original_assignment_name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "retry_duplicating_original_assignment_name_90b83bb8", "Retry duplicating \"%{original_assignment_name}\"", options) : helperMissing.call(depth0, "t", "retry_duplicating_original_assignment_name_90b83bb8", "Retry duplicating \"%{original_assignment_name}\"", options)))
    + "</span>\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "retry_ebd5f8ba", "Retry", options) : helperMissing.call(depth0, "t", "retry_ebd5f8ba", "Retry", options)))
    + "</span>\n    </button>\n    <button class=\"duplicate-failed-cancel btn\">\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'original_assignment_name': ((depth0 && depth0.original_assignment_name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "cancel_duplicating_original_assignment_name_e974c534", "Cancel duplicating \"%{original_assignment_name}\"", options) : helperMissing.call(depth0, "t", "cancel_duplicating_original_assignment_name_e974c534", "Cancel duplicating \"%{original_assignment_name}\"", options)))
    + "</span>\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</span>\n    </button>\n  </div>\n";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isImporting), {hash:{},inverse:self.program(22, program22, data),fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program20(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"ig-row__layout\">\n    ";
  stack1 = self.invokePartial(partials['ui/shared/spinner/jst/_spinner.handlebars'], 'ui/shared/spinner/jst/_spinner.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "importing_name_8f2b131d", "Importing \"%{name}\"", options) : helperMissing.call(depth0, "t", "importing_name_8f2b131d", "Importing \"%{name}\"", options)))
    + "\n  </div>\n";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.failedToImport), {hash:{},inverse:self.program(25, program25, data),fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <span aria-live=\"polite\" role=\"alert\" aria-atomic=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "oops_something_went_wrong_importing_name_d382cac1", "Oops! Something went wrong importing \"%{name}\"", options) : helperMissing.call(depth0, "t", "oops_something_went_wrong_importing_name_d382cac1", "Oops! Something went wrong importing \"%{name}\"", options)))
    + "</span>\n  <div class=\"import-failed-actions\">\n    <button class=\"import-failed-cancel btn\">\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "cancel_importing_name_a0b6f3e1", "Cancel importing \"%{name}\"", options) : helperMissing.call(depth0, "t", "cancel_importing_name_a0b6f3e1", "Cancel importing \"%{name}\"", options)))
    + "</span>\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</span>\n    </button>\n  </div>\n";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <div class=\"ig-row__layout\">\n\n    <div class=\"ig-type-icon\">\n      <i class=\"icon-quiz";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.useQuizzesNextIcon), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" aria-hidden=\"true\"></i>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isQuizzesNextAndNotStudent), {hash:{},inverse:self.program(30, program30, data),fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n\n    <div class=\"ig-info\">\n      <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.quizzesRespondusEnabled), {hash:{},inverse:self.noop,fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " class=\"ig-title\">\n        ";
  if (helper = helpers.title_label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title_label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n      </a>\n      <div class=\"ig-details\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showAvailability), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showDueDate), {hash:{},inverse:self.noop,fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.possible_points_label), {hash:{},inverse:self.noop,fn:self.program(38, program38, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.question_count_label), {hash:{},inverse:self.noop,fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canOpenManageOptions), {hash:{},inverse:self.noop,fn:self.program(42, program42, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n";
  return buffer;
  }
function program26(depth0,data) {
  
  
  return " icon-Solid";
  }

function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "new_quiz_34aacba6", "New Quiz", options) : helperMissing.call(depth0, "t", "new_quiz_34aacba6", "New Quiz", options)))
    + "</span>\n      ";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "quiz_e0dcce8f", "Quiz", options) : helperMissing.call(depth0, "t", "quiz_e0dcce8f", "Quiz", options)))
    + "</span>\n      ";
  return buffer;
  }

function program32(depth0,data) {
  
  
  return "target=\"_blank\"";
  }

function program34(depth0,data) {
  
  
  return "\n        <div class=\"ig-details__item date-available\" data-view=\"date-available\"></div>\n        ";
  }

function program36(depth0,data) {
  
  
  return "\n        <div class=\"ig-details__item date-due\" data-view=\"date-due\"></div>\n        ";
  }

function program38(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <div class=\"ig-details__item\">";
  if (helper = helpers.possible_points_label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.possible_points_label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n        ";
  return buffer;
  }

function program40(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <div class=\"ig-details__item\">";
  if (helper = helpers.question_count_label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.question_count_label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n        ";
  return buffer;
  }

function program42(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showSpeedGraderLinkFlag), {hash:{},inverse:self.program(72, program72, data),fn:self.program(43, program43, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program43(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div class=\"ig-admin\">\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isTrigger), {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isReleased), {hash:{},inverse:self.noop,fn:self.program(46, program46, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.noop,fn:self.program(48, program48, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          <div class=\"inline-block\">\n            <button class=\"al-trigger al-trigger-gray Button--icon-action\" aria-haspopup=\"true\" aria-owns=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-1\" role=\"button\">\n              <i class=\"icon-more\" aria-hidden=\"true\"></i>\n              <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "options_for_title_label_17f821ff", "Options for %{title_label}", options) : helperMissing.call(depth0, "t", "options_for_title_label_17f821ff", "Options for %{title_label}", options)))
    + "</span>\n            </button>\n\n            <ul id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-1\" class=\"al-options\" role=\"menu\" tabindex=\"0\" aria-hidden=\"true\" aria-expanded=\"false\" aria-activedescendant=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-2\">\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.noop,fn:self.program(50, program50, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canShowQuizBuildShortCut), {hash:{},inverse:self.noop,fn:self.program(52, program52, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(54, program54, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.assignment_id), (depth0 && depth0.showSpeedGraderLink), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.assignment_id), (depth0 && depth0.showSpeedGraderLink), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDuplicate), {hash:{},inverse:self.noop,fn:self.program(57, program57, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.is_locked), {hash:{},inverse:self.noop,fn:self.program(59, program59, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(64, program64, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.can_update), (depth0 && depth0.migrateQuizEnabled), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.can_update), (depth0 && depth0.migrateQuizEnabled), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.DIRECT_SHARE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(66, program66, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(68, program68, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.can_update), ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isCyoeAble), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.can_update), ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isCyoeAble), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.noop,fn:self.program(70, program70, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </ul>\n          </div>\n        </div>\n      ";
  return buffer;
  }
function program44(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <a href=\"";
  if (helper = helpers.edit_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.edit_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "?return_to=";
  if (helper = helpers.return_to) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "#mastery-paths-editor\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options) : helperMissing.call(depth0, "t", "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a>\n          ";
  return buffer;
  }

function program46(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <span class=\"pill mastery-path-icon\" aria-hidden=\"true\" data-tooltip title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'cyoe.releasedLabel': (((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options) : helperMissing.call(depth0, "t", "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options)))
    + "\">\n            <i class=\"icon-mastery-path\"></i>"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n          </span>\n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'cyoe.releasedLabel': (((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options) : helperMissing.call(depth0, "t", "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options)))
    + "</span>\n          ";
  return buffer;
  }

function program48(depth0,data) {
  
  
  return "\n              <span class=\"sis-button\" data-view=\"sis-button\"></span>\n              <span data-view=\"lock-icon\" class=\"lock-icon\"></span>\n              <span data-view=\"publish-icon\" class=\"publish-icon\"></span>\n          ";
  }

function program50(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li role=\"presentation\">\n                  <a href=\"";
  if (helper = helpers.edit_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.edit_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-2\" class=\"icon-edit\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "edit_quiz_ededddd8", "Edit Quiz", options) : helperMissing.call(depth0, "t", "edit_quiz_ededddd8", "Edit Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a>\n                </li>\n              ";
  return buffer;
  }

function program52(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li role=\"presentation\">\n                  <a href=\"";
  if (helper = helpers.build_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.build_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-5\" class=\"icon-quiz\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "build_quiz_df7e734a", "Build Quiz", options) : helperMissing.call(depth0, "t", "build_quiz_df7e734a", "Build Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "build_78955b82", "Build", options) : helperMissing.call(depth0, "t", "build_78955b82", "Build", options)))
    + "</a>\n                </li>\n              ";
  return buffer;
  }

function program54(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li role=\"presentation\" class=\"speed-grader-link-container ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.initialUnpublishedState), {hash:{},inverse:self.noop,fn:self.program(55, program55, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n                  <a href=\"/courses/";
  if (helper = helpers.courseId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.courseId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "/gradebook/speed_grader?assignment_id=";
  if (helper = helpers.assignment_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.assignment_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-6\" class=\"icon-speed-grader speed-grader-link\" tabindex=\"-1\" role=\"menuitem\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "navigate_to_speed_grader_for_name_f28cb5b1", "Navigate to Speed Grader for %{name}", options) : helperMissing.call(depth0, "t", "navigate_to_speed_grader_for_name_f28cb5b1", "Navigate to Speed Grader for %{name}", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "speedgrader_de0affa6", "SpeedGrader", options) : helperMissing.call(depth0, "t", "speedgrader_de0affa6", "SpeedGrader", options)))
    + "</a>\n                </li>\n              ";
  return buffer;
  }
function program55(depth0,data) {
  
  
  return "hidden";
  }

function program57(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <li>\n                <a\n                  class=\"duplicate_assignment icon-copy-course\"\n                  id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_duplicate_item\"\n                  aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "duplicate_quiz_name_79fdcb3e", "Duplicate Quiz %{name}", options) : helperMissing.call(depth0, "t", "duplicate_quiz_name_79fdcb3e", "Duplicate Quiz %{name}", options)))
    + "\"\n                  data-focus-returns-to\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "duplicate_31cec192", "Duplicate", options) : helperMissing.call(depth0, "t", "duplicate_31cec192", "Duplicate", options)))
    + "</a>\n              </li>\n              ";
  return buffer;
  }

function program59(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                <li role=\"presentation\">\n                ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1['delete']), {hash:{},inverse:self.program(62, program62, data),fn:self.program(60, program60, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                </li>\n              ";
  return buffer;
  }
function program60(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-3\" class=\"delete-item icon-trash\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "delete_quiz_142b8099", "Delete Quiz", options) : helperMissing.call(depth0, "t", "delete_quiz_142b8099", "Delete Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "</a>\n                ";
  return buffer;
  }

function program62(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <a id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-3\" class=\"delete-item icon-trash disabled\" aria-disabled=\"true\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "delete_quiz_142b8099", "Delete Quiz", options) : helperMissing.call(depth0, "t", "delete_quiz_142b8099", "Delete Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "</a>\n                ";
  return buffer;
  }

function program64(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li role=\"presentation\">\n                  <a href=\"#\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-4\" class=\"icon-export migrate\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "migrate_quiz_5d0f777", "Migrate Quiz", options) : helperMissing.call(depth0, "t", "migrate_quiz_5d0f777", "Migrate Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "migrate_67c9f753", "Migrate", options) : helperMissing.call(depth0, "t", "migrate_67c9f753", "Migrate", options)))
    + "</a>\n                </li>\n              ";
  return buffer;
  }

function program66(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <li role=\"presentation\">\n                  <a href=\"#\" class=\"icon-user quiz-send-to\" role=\"menuitem\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "send_quiz_to_user_e8c47177", "Send Quiz to User", options) : helperMissing.call(depth0, "t", "send_quiz_to_user_e8c47177", "Send Quiz to User", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "send_to_7881bf0e", "Send to...", options) : helperMissing.call(depth0, "t", "send_to_7881bf0e", "Send to...", options)))
    + "</a>\n                </li>\n                <li role=\"presentation\">\n                  <a href=\"#\" class=\"icon-duplicate quiz-copy-to\" role=\"menuitem\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "copy_quiz_to_course_74f9c8c1", "Copy Quiz to Course", options) : helperMissing.call(depth0, "t", "copy_quiz_to_course_74f9c8c1", "Copy Quiz to Course", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "copy_to_a5396a6f", "Copy to...", options) : helperMissing.call(depth0, "t", "copy_to_a5396a6f", "Copy to...", options)))
    + "</a>\n                </li>\n              ";
  return buffer;
  }

function program68(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li role=\"presentation\">\n                  <a href=\"";
  if (helper = helpers.edit_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.edit_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "?return_to=";
  if (helper = helpers.return_to) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "#mastery-paths-editor\" class=\"icon-mastery-path\" tabindex=\"-1\" role=\"menuitem\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options) : helperMissing.call(depth0, "t", "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a>\n                </li>\n              ";
  return buffer;
  }

function program70(depth0,data) {
  
  var stack1;
  stack1 = self.invokePartial(partials['ui/shared/external-tools/jst/_external_tools_menu.handlebars'], 'ui/shared/external-tools/jst/_external_tools_menu.handlebars', (depth0 && depth0.quiz_menu_tools), helpers, partials, data);
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }

function program72(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div class=\"ig-admin\">\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isTrigger), {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isReleased), {hash:{},inverse:self.noop,fn:self.program(46, program46, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.noop,fn:self.program(48, program48, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          <div class=\"inline-block\">\n            <button class=\"al-trigger al-trigger-gray Button--icon-action\" aria-haspopup=\"true\" aria-owns=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-1\" role=\"button\">\n              <i class=\"icon-more\" aria-hidden=\"true\"></i>\n              <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "options_for_title_label_17f821ff", "Options for %{title_label}", options) : helperMissing.call(depth0, "t", "options_for_title_label_17f821ff", "Options for %{title_label}", options)))
    + "</span>\n            </button>\n\n            <ul id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-1\" class=\"al-options\" role=\"menu\" tabindex=\"0\" aria-hidden=\"true\" aria-expanded=\"false\" aria-activedescendant=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-2\">\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.noop,fn:self.program(50, program50, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canShowQuizBuildShortCut), {hash:{},inverse:self.noop,fn:self.program(52, program52, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDuplicate), {hash:{},inverse:self.noop,fn:self.program(57, program57, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(73, program73, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.can_update), ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isCyoeAble), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.can_update), ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isCyoeAble), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.is_locked), {hash:{},inverse:self.noop,fn:self.program(59, program59, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(64, program64, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.can_update), (depth0 && depth0.migrateQuizEnabled), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.can_update), (depth0 && depth0.migrateQuizEnabled), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.DIRECT_SHARE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(66, program66, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.noop,fn:self.program(70, program70, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </ul>\n          </div>\n        </div>\n      ";
  return buffer;
  }
function program73(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <li role=\"presentation\">\n                  <a href=\"";
  if (helper = helpers.edit_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.edit_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "?return_to=";
  if (helper = helpers.return_to) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "#mastery-paths-editor\" class=\"icon-mastery-path\" tabindex=\"-1\" role=\"menuitem\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options) : helperMissing.call(depth0, "t", "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.quiz_item_view")
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a>\n              </li>\n              ";
  return buffer;
  }

  buffer += "<div id=\"summary_quiz_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isMigrating), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  